import { render, staticRenderFns } from "./FooterWarnings.vue?vue&type=template&id=11945c46&scoped=true"
import script from "./FooterWarnings.vue?vue&type=script&lang=js"
export * from "./FooterWarnings.vue?vue&type=script&lang=js"
import style0 from "./FooterWarnings.vue?vue&type=style&index=0&id=11945c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11945c46",
  null
  
)

export default component.exports